import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

import { UdcsService } from '../../Service/udcs-service';
import { ToastService } from '../../Service/toast-service';
//import { FormsModule } from '@angular/forms';

//import { Udcs } from '../../Udcs/udcs';

@Component({
  selector: 'app-udc-add',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],  
  templateUrl: './udc-add.html',
  styleUrl: './udc-add.css',
})
export class UdcAdd implements OnInit {
  udcForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UdcAdd>,
    private udcService: UdcsService,
    public toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.udcForm = this.fb.group({
      udcSystem: ['', [Validators.required, Validators.maxLength(10)]],
      udcKey: ['', [Validators.required, Validators.maxLength(10)]],
      description: ['', [Validators.required, Validators.maxLength(255)]],
      strValue1: [''],
      strValue2: [''],
      booleanValue: [true]
    });
  }

  onSubmit(): void {
    if (this.udcForm.invalid) {
      this.udcForm.markAllAsTouched();
      this.toastService.showDanger('Captura Requerida', 'Por favor, llene los campos obligatorios del catálogo.');
      return;
    }

    const payload = {
      udcSystem: this.udcForm.value.udcSystem.trim().toUpperCase(),
      udcKey: this.udcForm.value.udcKey.trim().toUpperCase(),
      description: this.udcForm.value.description.trim().toUpperCase(),
      strValue1: this.udcForm.value.strValue1?.trim().toUpperCase() || null,
      strValue2: this.udcForm.value.strValue2?.trim().toUpperCase() || null,
      booleanValue: this.udcForm.value.booleanValue
    };

    console.log('Insertando nueva clave UDC en caliente:', payload);

    // Invocamos tu método POST real validado de tu UdcsService
    this.udcService.createUdc(payload as any).subscribe({
      next: (res) => {
        //this.dialogRef.close(res);
        this.dialogRef.close(res || true) // 🚀 Envía la respuesta o true al guardar
      },
      error: (err) => {
        console.error(err);
        this.toastService.showDanger('Error de Persistencia', 'El servidor rechazó el alta. Verifique llaves duplicadas.');
      }
    });
  }

  onCancelar(): void {
    this.dialogRef.close(false); // 🚀 Envía un false explícito al cancelar
  }

}